module.exports = new __parcel__URL__("CL-May-Week2.c9fa966e.png").toString();